import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  background: #fafafa;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
`;

export const ResizeHandle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;

  &:hover,
  &:active {
    background: #1976d2;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;

  h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const SidebarActions = styled.div`
  display: flex;
  gap: 4px;
`;

export const SidebarSearch = styled.input`
  width: 100%;
  padding: 6px 10px;
  font-size: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  outline: none;
  margin: 8px 12px 4px;
  box-sizing: border-box;
  width: calc(100% - 24px);

  &:focus {
    border-color: #1976d2;
  }
`;

export const SidebarContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
`;

export const TreeItem = styled.div<{ $depth: number; $selected?: boolean; $dropTarget?: boolean }>`
  display: flex;
  align-items: center;
  padding: 6px 8px 6px ${(props) => 16 + props.$depth * 20}px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  background: ${(props) => (props.$dropTarget ? '#bbdefb' : props.$selected ? '#e3f2fd' : 'transparent')};
  user-select: none;
  border-top: ${(props) => (props.$dropTarget ? '2px solid #1976d2' : '2px solid transparent')};
  position: relative;

  &:hover {
    background: ${(props) => (props.$dropTarget ? '#bbdefb' : props.$selected ? '#e3f2fd' : '#f0f0f0')};
  }

  svg {
    margin-right: 8px;
    font-size: 14px;
    flex-shrink: 0;
  }
`;

export const TreeItemName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

export const TreeItemActions = styled.div`
  display: none;
  align-items: center;
  font-size: 10px;
  position: absolute;
  right: 4px;
  top: 0;
  bottom: 0;
  background: inherit;
  padding-left: 8px;

  ${TreeItem}:hover & {
    display: flex;
  }
`;

export const MenuWrapper = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 140px;
  padding: 4px 0;
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  color: #333;
  white-space: nowrap;

  &:hover {
    background: #f0f0f0;
  }

  svg {
    width: 12px;
    font-size: 11px;
    color: #666;
    margin-right: 0;
  }
`;

export const DropdownDivider = styled.div`
  height: 1px;
  background: #e0e0e0;
  margin: 4px 0;
`;

export const IconBtn = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
  color: #666;
  font-size: inherit;
  display: flex;
  align-items: center;

  &:hover {
    background: #ddd;
    color: #333;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const TabBar = styled.div`
  display: flex;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  overflow-x: auto;
  flex-shrink: 0;

  &::-webkit-scrollbar {
    height: 3px;
  }
`;

export const Tab = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  border-right: 1px solid #e0e0e0;
  background: ${(props) => (props.$active ? '#fff' : 'transparent')};
  border-bottom: ${(props) => (props.$active ? '2px solid #1976d2' : '2px solid transparent')};
  color: ${(props) => (props.$active ? '#333' : '#888')};
  font-weight: ${(props) => (props.$active ? 500 : 400)};

  &:hover {
    background: ${(props) => (props.$active ? '#fff' : '#eee')};
  }
`;

export const TabClose = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  font-size: 10px;
  color: #999;

  &:hover {
    background: #ddd;
    color: #333;
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  flex-shrink: 0;
`;

export const ContentTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

export const ContentMeta = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

export const Breadcrumbs = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 2px;

  span {
    color: #999;
  }

  span:last-child {
    color: #666;
  }
`;

export const ContentActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ContentBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`;

export const ActionButton = styled.button<{ $primary?: boolean; $danger?: boolean }>`
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid ${(props) => (props.$primary ? '#1976d2' : props.$danger ? '#d32f2f' : '#ccc')};
  background: ${(props) => (props.$primary ? '#1976d2' : props.$danger ? '#d32f2f' : '#fff')};
  color: ${(props) => (props.$primary || props.$danger ? '#fff' : '#333')};

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-size: 14px;
`;

export const EditorContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .toastui-editor-defaultUI {
    flex: 1;
    border: none;
    border-top: 1px solid #e0e0e0;
  }
`;

export const EditorTitleInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 4px 8px;
  font-size: 16px;
  font-weight: 600;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  outline: none;
  margin-right: 12px;

  &:focus {
    border-color: #1976d2;
  }
`;

export const VersionPanel = styled.div`
  width: 320px;
  min-width: 320px;
  border-left: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  overflow: hidden;
`;

export const VersionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;

  h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const VersionList = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const VersionItem = styled.div<{ $selected?: boolean }>`
  padding: 10px 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  background: ${(props) => (props.$selected ? '#e3f2fd' : 'transparent')};

  &:hover {
    background: ${(props) => (props.$selected ? '#e3f2fd' : '#f5f5f5')};
  }
`;

export const VersionNumber = styled.div`
  font-weight: 600;
  font-size: 13px;
`;

export const VersionMeta = styled.div`
  font-size: 11px;
  color: #888;
  margin-top: 2px;
`;

export const DiffContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
  font-size: 12px;
`;

export const MarkdownContent = styled.div`
  line-height: 1.6;
  font-size: 14px;

  h1, h2, h3, h4, h5, h6 {
    margin-top: 1em;
    margin-bottom: 0.5em;
  }

  p {
    margin: 0.5em 0;
  }

  code {
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 13px;
  }

  pre {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
    overflow-x: auto;
  }

  pre code {
    padding: 0;
    background: transparent;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
  }

  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background: #f5f5f5;
  }

  blockquote {
    border-left: 3px solid #ddd;
    margin: 1em 0;
    padding-left: 1em;
    color: #666;
  }

  img {
    max-width: 100%;
  }

  ul, ol {
    padding-left: 1.5em;
  }
`;
